import React from "react";
import { useLocation, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import InnerBanner from "../components/InnerBanner";
import Faqs from "../components/Faqs";
import serviceBg from "../assets/hero3.png";
import { getBrandPageData } from "../data/brandPageData";
import "./BrandService.css";

const formatServiceTitle = (serviceSlug) => {
  const words = serviceSlug.split("-");
  return words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

const BrandServiceDetailPage = () => {
  const { slug } = useParams();
  const location = useLocation();
  const actualSlug = slug || location.pathname.replace(/^\//, "");

  if (!actualSlug) {
    return null;
  }

  const normalizedSlug = actualSlug.trim().toLowerCase();
  const segments = normalizedSlug.replace(/-bangalore$/, "").split("-");
  const brandKey = segments[0];
  const serviceSlug = segments.slice(1).join("-");

  if (!brandKey || !serviceSlug) {
    return null;
  }

  const page = getBrandPageData(brandKey);

  if (!page) {
    return null;
  }

  const serviceTitle = formatServiceTitle(serviceSlug);
  const title = `${page.brand} ${serviceTitle}`;
  const description = `Customer Supports 24x7 offers ${page.brand} ${serviceTitle.toLowerCase()} in Bangalore with fast doorstep service and expert technicians.`;
  const details = `Our ${page.brand} ${serviceTitle.toLowerCase()} includes diagnosis, repair, and preventive maintenance for major ${page.brand} appliances.`;
  const serviceItems = [
    `${page.brand} ${serviceTitle} troubleshooting`,
    `${page.brand} ${serviceTitle} repair and parts replacement`,
    `Doorstep support for ${page.brand} appliance issues`,
  ];

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={`${brandKey} ${serviceSlug} bangalore, ${page.brand} service bangalore`} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content="https://customersupports24x7.in/customerSupport.png" />
        <meta property="og:url" content={`https://customersupports24x7.in/${slug}`} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content="https://customersupports24x7.in/customerSupport.png" />
        <link rel="canonical" href={`https://customersupports24x7.in/${slug}`} />
      </Helmet>

      <div className="brand-service-banner">
        <InnerBanner title={title} bgImage={serviceBg} brand={brandKey} />
      </div>

      <div className="brand-service-page">
        <div className="card">
          <h2>{title}</h2>
          <p style={{ textAlign: "justify" }}>{description}</p>
          <p style={{ textAlign: "justify" }}>{details}</p>
        </div>

        <div className="card">
          <h2>What We Cover</h2>
          <ul style={{ textAlign: "justify" }}>
            {serviceItems.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>

        <div className="card">
          <h2>Why Choose Our {page.brand} Service?</h2>
          <ul style={{ textAlign: "justify" }}>
            <li>Experienced technicians for {page.brand} appliances</li>
            <li>Same-day doorstep repair in Bangalore</li>
            <li>Clear diagnosis and honest recommendations</li>
            <li>Service support for major home appliance categories</li>
          </ul>
        </div>

        <div className="cta-box">
          <h3>Book {page.brand} {serviceTitle} Today</h3>
          <p style={{ textAlign: "justify", color: "#ffffff" }}>
            Call Customer Supports 24x7 to schedule quick {page.brand} {serviceTitle.toLowerCase()} anywhere in Bangalore.
          </p>
          <a href="tel:8050731754">
            <button className="call-btn">Call Now</button>
          </a>
        </div>
      </div>

      <Faqs />
    </>
  );
};

export default BrandServiceDetailPage;

